import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import TabMenu from './components/TabMenu';
import SensorContainer from './containers/SensorContainer';
import SampleDataContainer from './containers/SampleDataContainer';
import CsvDownloadContainer from './containers/CsvDownloadContainer';
import MonitoringContainer from './containers/MonitoringContainer';
import MonitoringPage from './pages/MonitoringPage';
import ChartPage from './pages/ChartPage';
import SearchPage from './pages/SearchPage';
import MachineGroupManager from './components/MachineGroupManager';
import './App.css';

function App() {
  const [activeTab, setActiveTab] = useState('monitoring');
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => (prev === 'light' ? 'dark' : 'light'));
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'search':
        return <SensorContainer />;
      case 'sample':
        return <SampleDataContainer />;
      case 'csv':
        return <CsvDownloadContainer />;
      case 'monitoring':
        return <MonitoringContainer />;
      case 'chart':
        return <ChartPage />;
      default:
        return <SensorContainer />;
    }
  };

  return (
    <Router>
      <Routes>
        <Route path="/monitoring" element={<MonitoringPage />} />
        <Route path="/chart" element={<ChartPage />} />
        <Route path="/machine" element={<MachineGroupManager />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/*" element={
          <div className="App">
            <div className="top-bar">
              <TabMenu activeTab={activeTab} onTabChange={setActiveTab} />
              <button onClick={toggleTheme} className="theme-toggle">
                {theme === 'light' ? '🌙' : '☀️'}
              </button>
            </div>
            {renderContent()}
          </div>
        } />
      </Routes>
    </Router>
  );
}

export default App;
